import React from 'react';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import WarningModal from 'src/pages/reportUsage/common/warningModal';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { USAGE_CREATED_VIA_INTEGRATION_STATUS_CODE } from 'src/constants/appConstants';

const PopupContainer = ({
    showWarningModel,
    usageDetailsFailureAlert,
    warningModalCloseHandler,
    showCancelPopupOnVendorCaseIdHandler,
    showOrderLockedPopup,
    usageProcessingPopup,
    closeUsageProcessingPopup,
    handleCloseOrderLockPopup,
    closeOrderLockedPopup,
    viewSurgeryNotes,
}) => {
    const { t } = useTranslation();
    const history = useHistory();

    const {
        myCaseRefId,
        usageDetails,
        usageOrderSubmission,
        fromOrdersList,
    } = useSelector(
        (state) => ({
            myCaseRefId:
                state.reportUsageRootReducer?.myCaseRefId ||
                history?.location?.pathname?.replace('/reportUsage/', ''),
            usageOrderSubmission:
                state.reportUsageRootReducer?.usageOrderSubmission,
            usageDetails: state.reportUsageRootReducer?.usageDetails,
            fromOrdersList: state.reportUsageRootReducer?.fromOrdersList,
        })
    );
    const isIntegrationUsageError =
        usageDetails?.status === 'failed' &&
        String(usageDetails?.statusCode) ===
            USAGE_CREATED_VIA_INTEGRATION_STATUS_CODE;

    return (
        <>
            {showWarningModel() && (
                <WarningModal
                    isSuccess={
                        usageOrderSubmission &&
                        usageOrderSubmission?.statusCode === '200'
                    }
                    message={
                        usageDetailsFailureAlert
                            ? isIntegrationUsageError
                                ? t(
                                      'reportUsage.record.reportPayment.ReportPayment.usageCreatedViaIntegration'
                                  )
                                : t(
                                      'reportUsage.record.reportPayment.ReportPayment.failedtofetch'
                                  )
                            : usageOrderSubmission?.statusCode === '200'
                            ? `${t(
                                  'reportUsage.record.reportPayment.ReportPayment.notemsg'
                              )} ${myCaseRefId}.`
                            : usageOrderSubmission?.statusDescription ||
                              usageOrderSubmission?.statusMessage
                    }
                    onClose={warningModalCloseHandler}
                    title={
                        usageDetailsFailureAlert
                            ? t(
                                  'reportUsage.record.reportPayment.ReportPayment.UsageDetailsFailure'
                              )
                            : usageOrderSubmission?.statusCode === '200'
                            ? t(
                                  'scheduleSurgery.surgery.notifications.DraftSaved.draftSuccessfullyCreatedPopup'
                              )
                            : t(
                                  'reportUsage.record.reportPayment.ReportPayment.DraftCreationFailed'
                              )
                    }
                    webHeight={
                        usageOrderSubmission &&
                        (usageOrderSubmission?.statusCode === '11908' ||
                            usageOrderSubmission?.statusCode === '11909')
                            ? '100px'
                            : '70px'
                    }
                    modalContentWidth={'375px'}
                    modalContentHeight={
                        usageOrderSubmission &&
                        usageOrderSubmission?.statusCode === '11908'
                            ? '140px'
                            : usageOrderSubmission?.statusCode === '11909'
                            ? '150px'
                            : '120px'
                    }
                    isVendorCaseIdError={
                        usageOrderSubmission &&
                        (usageOrderSubmission?.statusCode === '11908' ||
                            usageOrderSubmission?.statusCode === '11909')
                    }
                    vendorCaseErrorRedirection={
                        showCancelPopupOnVendorCaseIdHandler
                    }
                    statusCode={usageOrderSubmission?.statusCode}
                />
            )}
            {usageProcessingPopup && !showOrderLockedPopup.show && !viewSurgeryNotes && (
                <CancelAlertPopup
                    fitContent
                    popupTitle={t('orders.shipTrackLabels.usageProcessingTitle')}
                    alertMessage={t('orders.shipTrackLabels.usageProcessingMessage', {
                        orderNumber: usageProcessingPopup.myCaseRef,
                        userId: usageProcessingPopup.userId,
                    })}
                    btn1Label={t('reportUsage.common.cancel')}
                    cancelBtn
                    btnCloseClickHandler={closeUsageProcessingPopup}
                    btn1ClickHandler={closeUsageProcessingPopup}
                />
            )}
            {showOrderLockedPopup.show && !viewSurgeryNotes && (
                <CancelAlertPopup
                    popupTitle={t(
                        'orders.ordersListTableView.cancelAlertPopup.popupTitle'
                    )}
                    alertMessage={`${t('orders.shipTrackLabels.mycaseorder')} ${
                        showOrderLockedPopup.myCaseRef
                    } ${t('orders.shipTrackLabels.msg')} ${
                        showOrderLockedPopup.modifiedBy
                    }.`}
                    btn1Label={t('reportUsage.common.cancel')}
                    cancelBtn
                    btnCloseClickHandler={
                        fromOrdersList
                            ? closeOrderLockedPopup
                            : handleCloseOrderLockPopup
                    }
                    btn1ClickHandler={
                        fromOrdersList
                            ? closeOrderLockedPopup
                            : handleCloseOrderLockPopup
                    }
                />
            )}
        </>
    );
};

export default PopupContainer;
